import { CatalogsService } from './../../../services/catalogs/catalogs.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { ECService } from './../../../services/invoices-ec/ec.service';
import { InvoicesAService } from '../../../services/invoices-a/invoices-a.service';
import { StorageService } from '../../../services/storage.service';
import { User } from '../../../models/user';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-upload-aduanales',
  templateUrl: './upload-aduanales.component.html',
  styleUrls: ['./upload-aduanales.component.scss'],
  providers: [ECService, CatalogsService, InvoicesAService]
})
export class UploadAduanalesComponent implements OnInit {

  public user: User;
  @ViewChild('myTable') table: any;
  closeResult: string;

  rows: any[] = [];
  expanded: any = {};
  selected = [];

  entradasMercanciaSeleccionadas = [];
  totalOC;
  datos: any = [];
  personaContacto;
  cargaArchivosTitulo;
  cargaArchivos;
  errorEnvioDatos;
  envioDatos;
  verMensaje = false;
  mensaje1;
  cerrarModal;
  proveedor;
  arrayXml = [];
  uploadXml;
  arrayPdf = [];
  uploadPdf;
  flagPDF = false;
  flagXML = false;
  nombrePDF;
  nombreXML;
  importe;
  monedaSeleccionada;
  entradasMercanciaTmp = [];
  ordenCompraTmp = [];
  objJSONCabecera;
  objJSONRecords;
  identificadorDeLlamada;
  usuario;
  moneda;
  monedaValue;
  referencia;
  flagCfdi = false;
  flagConCfdi = false;
  paisUsuario;
  modalRespuesta;
  respuesta;
  titulo;
  mensaje;
  busy: boolean = false;
  autenticado;
  toastCargarArchivos;
  notaC: boolean = false;
  toggleMultiplesFacts: boolean = false;
  multiples;
  conNotaCredito: boolean = false;
  estatusEnvio;
  importeFactura: any = 0;
  pedimento = '';
  cuentaAgente = '';
  public form: FormGroup;

  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
  constructor(
    private translate: TranslateService,
    private storageService: StorageService,
    private InvoicesAService: InvoicesAService,
    private catalogos: CatalogsService,
    public activeModal: NgbActiveModal,
    private toasterService: ToasterService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder
  ) {
    this.translate.get('texto.toastCamposVacios').subscribe(
      text => {
        this.toastCargarArchivos = text;
      });
    this.translate.get('texto.cargarTodosLosArchivosTitulo').subscribe(
      text => {
        this.cargaArchivosTitulo = text;
      });
    this.translate.get('texto.cargarTodosLosArchivos').subscribe(
      text => {
        this.cargaArchivos = text;
      });
    this.translate.get('texto.tituloEnvioDatosError').subscribe(
      text => {
        this.errorEnvioDatos = text;
      });
    this.translate.get('texto.datosEnviados').subscribe(
      text => {
        this.envioDatos = text;
      });
  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.rows = this.entradasMercanciaSeleccionadas;

    this.importeTotal();
    this.obtenerMoneda();
    this.autenticado = this.storageService.isAuthenticated();

    this.form = this.formBuilder.group({
      correo: ['', Validators.compose([Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'),
      Validators.minLength(1)])]
    });
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  obtenerMoneda() {
    this.catalogos.obtenerMonedaPorModulo('P').subscribe(
      data => {
        this.moneda = data.moneda;
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );
  }

  importeTotal() {
    let total;

    this.monedaSeleccionada = this.entradasMercanciaSeleccionadas[0].clave_moneda;
    for (let i = 0; i < this.rows.length; i++) {
      total = parseFloat(this.rows[i].importe);
      this.importe += total;
    }

  }

  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
  }


  closeModal(mensaje) {
    if (mensaje == 'cancelar') {
      this.verMensaje = false;
      if (this.estatusEnvio == 'S') {
        this.activeModal.close('cerrar');
      }
    } else {
      this.activeModal.close('cancelar');
    }
  }
  enviarDatos(fileZIP: File) {
    this.datos = [];
    this.entradasMercanciaTmp = [];
    this.usuario = this.user.id;
    // let cfdi, proveedor;
    var entradas = [];
    var enviar;;

    // if (this.proveedor) {
    //   proveedor = this.proveedor
    // } else {
    //   proveedor = this.user.id
    // }

    // var idUsuario;
    // if (this.user.rol.id == 3) {
    //   idUsuario = this.user.id;
    // } else {
    //   idUsuario = this.proveedor;
    // }

    // if (this.paisUsuario == 'MX') {
    //   cfdi = false;
    // } else {
    //   cfdi = true;
    // }

    // if (filePDF) {
    //   nombrePDF = filePDF.name;
    // } else {
    //   nombrePDF = '';
    // }

    // if (fileXML) {
    //   nombreXML = fileXML.name;
    // } else {
    //   nombreXML = '';
    // }

    const proveedor = (this.proveedor) ? this.proveedor : this.user.id;
    const idUsuario = (this.user.rol.id === 3) ? this.user.id : this.proveedor;
    const cfdi: any = (this.paisUsuario == 'MX') ? false : true;
    const archivoZIP = (fileZIP) ? fileZIP.name : '';


    if (this.personaContacto == undefined) this.personaContacto = '';

    var ordenCompra: any = {
      idOrdenCompra: this.entradasMercanciaSeleccionadas[0].num_doc_comp,
      idProveedor: idUsuario,
      sociedad: this.entradasMercanciaSeleccionadas[0].sociedad,
      moneda: this.entradasMercanciaSeleccionadas[0].clave_moneda,
      totalOc: this.totalOC
    };

    ordenCompra = JSON.stringify(ordenCompra);

    for (let i = 0; i < this.entradasMercanciaSeleccionadas.length; i++) {
      const entradas_de_mercancia = {
        idOrdenCompra: this.entradasMercanciaSeleccionadas[i].num_doc_comp,
        noPosicion: this.entradasMercanciaSeleccionadas[i].poscicion_doc,
        cantidad: this.entradasMercanciaSeleccionadas[i].cantidad,
        ejerDocMatnr: this.entradasMercanciaSeleccionadas[i].ejercicio,
        fecha_cont: this.entradasMercanciaSeleccionadas[i].fecha_cont,
        idMaterial: this.entradasMercanciaSeleccionadas[i].num_doc_material,
        importeOC: this.entradasMercanciaSeleccionadas[i].importe,
        indicadorIva: this.entradasMercanciaSeleccionadas[i].ind_iva,
        posDocMatnr: this.entradasMercanciaSeleccionadas[i].num_apunte,
        precioUnitarioOC: this.entradasMercanciaSeleccionadas[i].precio_neto,
        referencia: this.entradasMercanciaSeleccionadas[i].num_doc_ref,
        unidad: this.entradasMercanciaSeleccionadas[i].unidad,
        moneda: this.entradasMercanciaSeleccionadas[i].clave_moneda,
        clase_cond: this.entradasMercanciaSeleccionadas[i].clase_cond,
        doc_ref: this.entradasMercanciaSeleccionadas[i].doc_ref,
        poscicion_doc: this.entradasMercanciaSeleccionadas[i].num_pos_doc_comp,
        denominacion: this.entradasMercanciaSeleccionadas[i].denominacion,
        texto_breve: this.entradasMercanciaSeleccionadas[i].texto_breve,
        num_apunte: this.entradasMercanciaSeleccionadas[i].num_apunte,
        orderpr_un: this.entradasMercanciaSeleccionadas[i].orderpr_un,
        clave_cond_pago: this.entradasMercanciaSeleccionadas[i].clave_cond_pago,
        costo_indirecto: this.entradasMercanciaSeleccionadas[i].costo_indirecto,
        num_nivel: this.entradasMercanciaSeleccionadas[i].num_nivel,
        cont_cond: this.entradasMercanciaSeleccionadas[i].cont_cond,
        HACK_KEY: '',
        bwart: this.entradasMercanciaSeleccionadas[i].bwart,
        noMat: this.entradasMercanciaSeleccionadas[i].noMat,
        tipocambio: this.entradasMercanciaSeleccionadas[i].tcambio,
        importeMonedaLocal: this.entradasMercanciaSeleccionadas[i].importeMonedaLocal,
        fechaPedido: this.entradasMercanciaSeleccionadas[i].fechaPedido,
        bewtp: this.entradasMercanciaSeleccionadas[i].bewtp,
        cond_type: this.entradasMercanciaSeleccionadas[i].cond_type,
        ZAEHK: this.entradasMercanciaSeleccionadas[i].ZAEHK,
        id: i
      };
      this.entradasMercanciaTmp.push(entradas_de_mercancia);
    } 
    entradas.push(this.entradasMercanciaTmp);

    this.datos.push({
      "entradaMercancia": entradas[0]
    });

    this.datos = JSON.stringify(this.datos);

    let numero = parseFloat(this.importeFactura);
    // Verificar si el valor es negativo y convertirlo a positivo
    if (numero < 0) {
      numero = Math.abs(numero);
    }
    // Limitar el número a 2 decimales
    const total = numero.toFixed(2);

    const formData: FormData = new FormData();
    formData.append('zip', fileZIP),
    formData.append('datos', this.datos),
    formData.append('ordenCompra', ordenCompra),
    formData.append('contacto', this.personaContacto)
    formData.append('proveedor', idUsuario)
    formData.append('importe', total)
    formData.append('pedimento', this.pedimento.replace(/\s+/g, ''))
    formData.append('cuenta', this.cuentaAgente.replace(/\s+/g, ''))

    enviar = (fileZIP && this.form.valid) ? true : false;


    // if (this.paisUsuario == 'MX') {
    //   if (fileXML && this.form.valid) {
    //     enviar = true;
    //   } else {
    //     enviar = false;
    //   }
    // } else {
    //   if (filePDF && this.form.valid) {
    //     enviar = true;
    //   } else {
    //     enviar = false;
    //   }

    // }

    if (fileZIP && this.importeFactura && this.pedimento.trim() !== '' &&  this.cuentaAgente.trim() !== '' && this.form.valid) {
      enviar = true;
    } else {
      enviar = false;
    }

    // console.log(formData, fileZIP, this.importeFactura, this.pedimento, this.cuentaAgente, enviar);

    if (enviar) {
      this.busy = true;
      this.InvoicesAService.cargarFacturaAduanales(formData).subscribe(
        data => {
          this.busy = false;

          if (data != null) {
            this.verMensaje = true;
            if (data.result.status == 'S') {
              this.titulo = this.envioDatos;
            } else {
              this.titulo = this.errorEnvioDatos;
            }

            this.mensaje1 = data.result.message;
            this.estatusEnvio = data.result.status;
          }

        },
        err => {
          this.busy = false;
          if (err.status === 401) {
            this.storageService.openLogout();
          } else {
            this.busy = false;
          }
        },
      );
    } else {
      this.toasterService.pop('error', 'Error', this.toastCargarArchivos);
    }


  }

  openMensajeRespuesta(mensajeRes) {
    this.modalRespuesta = this.modalService.open(mensajeRes, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalRespuesta.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }




}






// WEBPACK FOOTER //
// ./src/app/pages/invoices-aduanales/upload-aduanales/upload-aduanales.component.ts